'use client';

import React from 'react';
import SectionCard from '@/components/kb/SectionCard';
import { useArticles } from '@/context/ArticlesContext';

const kbSectionsConfig = [
  {
    id: 'cat-order-processing',
    icon: '📦',
    title: 'Order Processing',
    description: 'Master order workflows, SOPs, and step-by-step processing guides for every order type.',
    featured: true,
  },
  {
    id: 'cat-email-chat',
    icon: '💬',
    title: 'Email & Chat Workflow',
    description: 'Communication templates, response guidelines, and professional messaging standards.',
    featured: false,
  },
  {
    id: 'cat-cancellation',
    icon: '📋',
    title: 'Cancellation',
    description: 'Customer intake checklists, requirement gathering, and pricing & quote processes.',
    featured: false,
  },
  {
    id: 'cat-complaints',
    icon: '⚠️',
    title: 'Complaints',
    description: 'Handle escalations professionally with structured procedures for reprints and refunds.',
    featured: false,
  },
  {
    id: 'cat-general',
    icon: '📚',
    title: 'General Knowledge',
    description: 'Company overview, production timelines, FAQs, and general reference materials.',
    featured: false,
  },
  {
    id: 'cat-materials',
    icon: '✨',
    title: 'Materials & Finishes',
    description: 'Complete product knowledge hub for all cardstocks, special materials, and finish options.',
    featured: false,
  },
];

export default function KBSectionGrid() {
  const { articles, categories } = useArticles();

  const publishedArticles = articles?.filter(a => a?.published);

  const sections = kbSectionsConfig?.map(config => {
    // Try to find matching category by id or by name match
    const matchedCategory = categories?.find(c => c?.id === config?.id);
    const categoryId = matchedCategory ? matchedCategory?.id : config?.id;
    const count = publishedArticles?.filter(a => a?.category === categoryId)?.length;
    return {
      ...config,
      articleCount: count,
      href: `/section-article-list-page?category=${encodeURIComponent(categoryId)}`,
    };
  });

  return (
    <section>
      <div className="flex items-center justify-between mb-6">
        <div>
          <p className="section-label mb-1">Knowledge Sections</p>
          <h2 className="font-serif text-2xl font-semibold text-foreground">Browse by Category</h2>
        </div>
        <span className="text-xs text-muted-foreground hidden sm:block">{sections?.length} sections</span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-4">
        {sections?.map(section => (
          <SectionCard key={section?.id} {...section} />
        ))}
      </div>
    </section>
  );
}